if (window.CKEDITOR) {
  CKEDITOR.plugins.add('nbsp',
    {
      hidpi: true,
      lang: 'fr,en',
      init: function(editor) {
        let lang = editor.lang.nbsp;
        editor.addCommand('insertNbsp', {
          exec: function(editor) {
            editor.insertHtml('&nbsp;', 'text');
          },
        });
        editor.setKeystroke(CKEDITOR.CTRL + 32 /* space */, 'insertNbsp');
        editor.ui.addButton('nbsp', {
          label: lang.label,
          command: 'insertNbsp',
          toolbar: 'nbsp',
        });
      },
    });
}

require('./lang/fr');
require('./lang/en');
